module.exports = __webpack_public_path__ + "assets/img/everyone_average.58061de8.svg";